import {IProduct} from "../infrastructure/interfaces";
import {ActionType} from "../infrastructure/actionTypes";

export default (list: Array<IProduct>, action: any) => {
    switch (action.type) {
        case ActionType.GET_PRODUCTS_DONE:
            let sortedList = action.products.sort((a : {}, b: {}) => a['name'].localeCompare(b['name']))
            return [...sortedList];
        case ActionType.DELETE_PRODUCT_DONE:
            list = list.filter(d => {
                if (d.id !== action.deleteData.id) {
                    return true;
                }
                if (d.type !== action.deleteData.type) {
                    return true;
                }
                return false;
            });
            return list;
            case ActionType.TOGGLE_PRODUCT_PUBLISH_DONE:
                list = list.map(d => {
                    if (d.id !== action.publishData.id) {
                        return d;
                    }
                    if (d.type !== action.publishData.type) {
                        return d;
                    }
                    d.published = action.publishData.published;
                    return d;
                });
                return list;
            case ActionType.PRODUCT_UPDATE_DONE:
                list = list.map(d => {
                    if (d.id !== action.publishData.id) {
                        return d;
                    }
                    if (d.type !== action.publishData.type) {
                        return d;
                    }
                    
                    // The full product is in the updateData, so return it instead
                    return action.updateData;
                });
                return list.sort((a : {}, b: {}) => a['name'].localeCompare(b['name']))
            case ActionType.SAVE_PRODUCT_DONE:
                var productWasUpdated = false;
                list = list.map(d => {
                    if (d.id !== action.updatedProduct.id) {
                        return d;
                    }
                    if (d.type !== action.updatedProduct.type) {
                        return d;
                    }
                    
                    productWasUpdated = true;
                    return action.updatedProduct;
                });

                if (!productWasUpdated) {
                    list = list.concat(action.updatedProduct);
                }
                return list.sort((a : {}, b: {}) => a['name'].localeCompare(b['name']))
        default:
        {
            if (list == undefined) {
                return [];
            }
            return list;
        }
    }
};


// WEBPACK FOOTER //
// ./src/reducers/productList.ts